import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_PAGE_CALLS } from 'games/KenoGame/keno.constants'
import { getMyBetsRoulette, placedBetRouletteGame } from './rouletteGame.thunk'
import { getWinningBetTypes } from './game-helpers/index'
import { BET_RESULT } from 'constants/index'

const initialState = {
  placedBetData: null,
  betLock: false,
  betLoading: false,
  myBetsData: {
    count: 0,
    rows: []
  },
  myBetsLoading: false,
  showWin: false,
  recentWinning: [],
  winTypesContent: null,
  liveStatsData: {
    totalWins: 0,
    totalLost: 0,
    totalProfit: 0,
    totalWagered: 0
  }
}

const {
  actions: {
    setBetLock,
    setRouletteRoundEnd,
    appendMyBetsRoulette,
    setLiveStatsData,
    resetLiveStats
  },
  reducer
} = createSlice({
  name: 'rouletteGame',
  initialState,
  reducers: {
    setBetLock: (state, action) => {
      return {
        ...state,
        betLock: false
      }
    },
    setRouletteRoundEnd: (state, action) => {
      const liveData = { ...state.liveStatsData }
      const { betAmount, winningAmount, result } = state.placedBetData || {}

      if (result === BET_RESULT.WON) {
        liveData.totalWins = (liveData.totalWins || 0) + 1
      } else if (result === BET_RESULT.LOST) {
        liveData.totalLost = (liveData.totalLost || 0) + 1
      }

      if (!isNaN(parseFloat(betAmount))) {
        liveData.totalWagered = Number((parseFloat(liveData.totalWagered || 0) + parseFloat(betAmount)).toFixed(2))
      }

      if (!isNaN(parseFloat(winningAmount)) && !isNaN(parseFloat(betAmount)) && result !== 'push') {
        const profitDelta = (parseFloat(winningAmount) - parseFloat(betAmount)).toFixed(2)
        liveData.totalProfit = Number((parseFloat(liveData.totalProfit || 0) + parseFloat(profitDelta)).toFixed(2))
      }

      return {
        ...state,
        showWin: true,
        betLock: false,
        recentWinning: [state.placedBetData, ...state.recentWinning].slice(0, 4),
        liveStatsData: liveData
      }
    },
    appendMyBetsRoulette: (state, action) => {
      const { nextServerSeedHash, ...data } = state.placedBetData || { nextServerSeedHash: '', data: {} }
      if (nextServerSeedHash) {
        const myBetsDataRows = [data, ...state.myBetsData?.rows]
        if (myBetsDataRows.length > DEFAULT_PAGE_CALLS) {
          myBetsDataRows.pop()
        }
        return {
          ...state,
          myBetsData: {
            count: state.myBetsData?.count + 1,
            rows: myBetsDataRows
          }
        }
      }
      return state
    },
    setLiveStatsData: (state, action) => {
      const liveData = { ...state.liveStatsData }
      const { betAmount, winningAmount, result } = action.payload || {}
      if (!result || (result !== BET_RESULT.WON && result !== BET_RESULT.LOST)) {
        return // Handle invalid result values
      }

      if (result === BET_RESULT.WON) {
        liveData.totalWins = (liveData.totalWins || 0) + 1
      } else if (result === BET_RESULT.LOST) {
        liveData.totalLost = (liveData.totalLost || 0) + 1
      }

      if (!isNaN(parseFloat(betAmount))) {
        liveData.totalWagered = Number((parseFloat(liveData.totalWagered || 0) + parseFloat(betAmount)).toFixed(2))
      }

      if (!isNaN(parseFloat(winningAmount)) && !isNaN(parseFloat(betAmount)) && result !== 'push') {
        const profitDelta = (parseFloat(winningAmount) - parseFloat(betAmount)).toFixed(2)
        liveData.totalProfit = Number((parseFloat(liveData.totalProfit || 0) + parseFloat(profitDelta)).toFixed(2))
      }
      return ({
        ...state,
        liveStatsData: liveData
      })
    },
    resetLiveStats: (state, action) => {
      return {
        ...state,
        liveStatsData: initialState.liveStatsData
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placedBetRouletteGame.pending, (state, action) => {
        return {
          ...state,
          showWin: false,
          betLock: true,
          betLoading: true,
          winTypesContent: null
        }
      })
      .addCase(placedBetRouletteGame.fulfilled, (state, action) => {
        const { winningNumber } = action.payload || { winningNumber: 0 }

        const winTypesContent = getWinningBetTypes(winningNumber)

        return {
          ...state,
          winTypesContent,
          placedBetData: action.payload,
          betLoading: false
        }
      })
      .addCase(placedBetRouletteGame.rejected, (state, action) => {
        return {
          ...state,
          betLock: false,
          betLoading: false
        }
      })
      .addCase(getMyBetsRoulette.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true

        }
      })
      .addCase(getMyBetsRoulette.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false

        }
      })
      .addCase(getMyBetsRoulette.rejected, (state, action) => {
        return {
          ...state,
          myBetsLoading: false

        }
      })
  }
})

export {
  setBetLock,
  setRouletteRoundEnd,
  appendMyBetsRoulette,
  setLiveStatsData,
  resetLiveStats
}

export default reducer
